var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiaoliang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_2740)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 590",
    d: "M15.6281 5.28741L0.440552 5.47491V13.3499H2.37805V12.4124L3.00305 10.9749L4.56555 8.78741L7.2218 7.81866L10.4093 8.28741L12.5656 9.72491L13.5343 13.5062L15.6281 13.3499V5.28741Z",
    fill: "#89A3D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631276",
    d: "M2.86243 13.3547H1.40421H0.415771V5.31543H15.5718V13.3547H13.1281",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 83",
    d: "M13.6168 13.3547C13.6168 10.2492 11.0993 7.7316 7.99373 7.7316C4.88816 7.7316 2.37061 10.2492 2.37061 13.3547",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 0.371826,
    y1: 2.6189,
    x2: 15.5718,
    y2: 2.6189,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 2.32788,
    y1: 3.1189,
    x2: 2.32788,
    y2: 5.31543,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 5.22327,
    y1: 3.1189,
    x2: 5.22327,
    y2: 5.31543,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 8.11877,
    y1: 3.1189,
    x2: 8.11877,
    y2: 5.31543,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 10.9933,
    y1: 3.1189,
    x2: 10.9933,
    y2: 5.31543,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 13.8468,
    y1: 3.1189,
    x2: 13.8468,
    y2: 5.31543,
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiaoliang);
export default __webpack_public_path__ + "static/media/qiaoliang.e690f2d81ae0295682fa8762db2376c2.svg";
export { ForwardRef as ReactComponent };